import { fetchPaged } from "@/data/paging";
import { supabase } from "@/lib/supabase";
import type {
  CalendarActivity,
  CalendarQueryOpts,
} from "@/types/calendar.types";
import { nextInstantIso } from "@/utils/date.utils";

const HARD_LIMIT = 10_000;

export async function fetchCalendarActivities(
  q: CalendarQueryOpts,
): Promise<CalendarActivity[]> {
  return fetchPaged<CalendarActivity>(
    () => {
      let req = supabase
        .from("activities")
        .select(
          "strava_activity_id,start_date,name,type,sport_type,distance,moving_time,total_elevation_gain",
        )
        .eq("user_id", q.userId)
        .eq("is_deleted", false)
        .gte("start_date", q.from)
        .lt("start_date", nextInstantIso(q.to))
        .order("start_date", { ascending: false });

      if (q.search?.trim()) {
        const term = q.search.trim().replace(/[%_]/g, "\\$&");
        req = req.or(
          `name.ilike.%${term}%,sport_type.ilike.%${term}%,type.ilike.%${term}%`,
        );
      }

      switch (q.sports?.mode) {
        case "include": {
          if (q.sports.sports.length === 0) {
            req = req.eq("sport_type", "__none__");
          } else {
            req = req.in("sport_type", q.sports.sports);
          }
          break;
        }
        case "exclude": {
          if (q.sports.sports.length > 0) {
            req = req.not("sport_type", "in", `(${q.sports.sports.join(",")})`);
          }
          break;
        }
        case "all":
        default:
          break;
      }
      return req;
    },
    {
      limit: q.limit,
      hardLimit: HARD_LIMIT,
    },
  );
}
